import {
    CONTRACTOR_SETTINGS_REQUEST,
    CONTRACTOR_SETTINGS_SUCCESS,
    CONTRACTOR_SETTINGS_FAILURE,
    CONTRACTOR_SETTING_ADD_REQUEST,
    CONTRACTOR_SETTING_ADD_SUCCESS,
    CONTRACTOR_SETTING_ADD_FAILURE,
    CONTRACTOR_SETTING_UPDATE_REQUEST,
    CONTRACTOR_SETTING_UPDATE_SUCCESS,
    CONTRACTOR_SETTING_UPDATE_FAILURE,
    CONTRACTOR_SETTING_DELETE_REQUEST,
    CONTRACTOR_SETTING_DELETE_SUCCESS,
    CONTRACTOR_SETTING_DELETE_FAILURE
} from '../actions';

export const CONTRACTOR_SETTINGS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null
};

const settingsReducers = {
    [CONTRACTOR_SETTINGS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_SETTINGS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_SETTINGS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_SETTING_ADD_SUCCESS]: (state, {res}) => {
        const settings = [...state.data];
        const setting = settings.find(i => i.id === res.reference_id);
        setting.config = res;

        return {...state, data: settings, isFetching: false, error: null};
    },
    [CONTRACTOR_SETTING_ADD_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_SETTING_UPDATE_SUCCESS]: (state, {res}) => {
        const settings = [...state.data];
        const setting = settings.find(i => i.id === res.reference_id);
        setting.config = res;

        return {...state, data: settings, isFetching: false, error: null};
    },
    [CONTRACTOR_SETTING_UPDATE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_SETTING_DELETE_SUCCESS]: (state, {reference}) => {
        const settings = [...state.data];
        const setting = settings.find(i => i.id === reference);
        setting.config = null;

        return {...state, data: settings, isFetching: false, error: null};
    },
    [CONTRACTOR_SETTING_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    }
};

export default function settings(state = CONTRACTOR_SETTINGS_INITIAL_STATE, action) {
    let reducer = settingsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-settings.js